import * as tslib_1 from "tslib";
import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';
var nextId = 0;
export default action('addNotification')(function addNotification(notificationViewState) {
    var notification = tslib_1.__assign({ id: nextId++ }, notificationViewState);
    store.notificationViewStates.push(notification);
});
//# sourceMappingURL=addNotification.js.map